module.exports = "\n\n\n    <empty-list-state class=\"absolute-center-flex\"\n        title-message=\"'discount_for_staff_transaction_export_history_tab_empty_message_title' | translate\"\n        message=\"'discount_for_staff_transaction_export_history_tab_empty_message' | translate\">\n    </empty-list-state>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app.retailer/modules/discountForStaff/transaction-tab/transaction-export-history/transaction-export-history.component.html
// module id = 743
// module chunks = 0